import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaCoins, FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import "./Navbar.css";

const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About Us", id: "about" },
  { label: "Services", id: "services" },
  { label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sections = NAV_LINKS.map((l) => document.getElementById(l.id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px" }
    );
    sections.forEach((s) => observer.observe(s));
    return () => sections.forEach((s) => observer.unobserve(s));
  }, []);

  const handleNavClick = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      className={`lf-navbar ${scrolled ? "lf-navbar--scrolled" : ""}`}
      initial={{ y: -90, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="lf-navbar__inner container">
        <a href="#home" className="lf-navbar__brand" onClick={(e) => { e.preventDefault(); handleNavClick("home"); }}>
          <span className="lf-navbar__brand-icon">
            {/* <FaCoins /> */} <img src="/lintlogoco.png" alt="Lint Logo" />
          </span>
          <span className="lf-navbar__brand-text">
            LENT <span>FINANCE</span>
          </span>
        </a>

        <nav className="lf-navbar__links">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              className={`lf-navbar__link ${activeSection === link.id ? "is-active" : ""}`}
              onClick={() => handleNavClick(link.id)}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="lf-navbar__actions">
          <a href="tel:7034644555" className="lf-navbar__phone">
            <FaPhoneAlt /> <span>70346 44555</span>
          </a>
          <button className="btn btn-primary lf-navbar__cta" onClick={() => handleNavClick("contact")}>
            Apply Now
          </button>
        </div>

        <button className="lf-navbar__burger" onClick={() => setMenuOpen((v) => !v)} aria-label="Toggle menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="lf-navbar__mobile"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
          >
            {NAV_LINKS.map((link) => (
              <button key={link.id} className="lf-navbar__mobile-link" onClick={() => handleNavClick(link.id)}>
                {link.label}
              </button>
            ))}
            <button className="btn btn-primary lf-navbar__mobile-cta" onClick={() => handleNavClick("contact")}>
              Apply Now
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
